import parashaList from '../../parasha_map.json';

export type Parasha = { english: string; hebrew: string };

const normalizeParashaKey = (name: string) =>
  name
    .toLowerCase()
    .replace(/^parashat\s+/, '')
    .replace(/[^a-z]/g, '');

const canonicalMap = new Map<string, Parasha>();
(parashaList as Parasha[]).forEach((p) => canonicalMap.set(normalizeParashaKey(p.english), p));

// Known transliteration differences between Hebcal and our canonical names
const hebcalAliases: Record<string, string> = {
  bereishit: 'Bereshit',
  nasso: 'Naso',
  behaalotcha: 'Behaalotecha',
  shlach: 'Shelach',
  shmini: 'Shemini',
  vayetzei: 'Vayetze',
  vayeilech: 'Vayelech',
  achreimot: 'Acharei Mot',
};

const lookupSimple = (name: string): Parasha | null => {
  const normalized = normalizeParashaKey(name);
  const aliasTarget = hebcalAliases[normalized];
  const aliasKey = aliasTarget ? normalizeParashaKey(aliasTarget) : null;

  return canonicalMap.get(normalized) || (aliasKey ? canonicalMap.get(aliasKey) : null) || null;
};

/**
 * Map a Hebcal parasha description (e.g., "Parashat Ha'azinu" or "Matot-Masei")
 * to the matching entry in `parasha_map.json`.
 */
export function mapHebcalParasha(raw?: string | null): Parasha | null {
  if (!raw) return null;
  const cleaned = raw.replace(/^Parashat\s+/i, '').trim();

  const direct = lookupSimple(cleaned);
  if (direct) return direct;

  // Handle combined readings (e.g., "Tazria-Metzora")
  const parts = cleaned
    .split(/[-–]/)
    .map((p) => p.trim())
    .filter(Boolean);
  for (const part of parts) {
    const match = lookupSimple(part);
    if (match) return match;
  }

  return null;
}

export function getParashaByEnglish(name: string): Parasha | null {
  return lookupSimple(name);
}
